import React, { Component } from 'react';
import Moment from 'react-moment';
import { Input, Icon } from 'react-materialize';
import { Link } from "react-router-dom";

import FileUtils from '../../utils/FileUtils';
import CommonConstants from '../../constants/CommonConstants';
import AssetView from '../../views/assets-view/AssetsView';

import defaultThumbnail from '../../images/EmptyPicture.png';
import './DownloadsList.css';

class DownloadsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: props.title ? props.title : 'Downloads',
      files: props.files ? props.files : []
    }

    this._showThumbnails = props.showThumbnails !== undefined;

    this._externalHandlers = {
      fileListChanged: props.onFileListChanged,
      assetSelected: props.onAssetSelected
    }

    this.clear = this.clear.bind(this);
    this._handleSelectedFileChange = this._handleSelectedFileChange.bind(this);
    this._handleAssetSelected = this._handleAssetSelected.bind(this);
  }

  handleThumbnailError(event) {
    let thumbnail = event.target;
    thumbnail.onerror = null;
    thumbnail.src = defaultThumbnail
  }

  clear() {
    this.setState({ selectedFiles: new Map() });
  }

  _handleSelectedFileChange(event) {
    let checkbox = event.target;

    let selectedFiles = new Map();
    let deletedFile = "";
    if (checkbox.checked) {
      selectedFiles.set(checkbox.value, checkbox.name);
    } else {
      deletedFile = checkbox.value;
    }

    if (this._externalHandlers.selectedFileChanged !== null) {
      let event = new Event('selectedFileChanged');
      event.details = { selectedFiles: selectedFiles, deletedFile: deletedFile };
      this._externalHandlers.fileListChanged(event);
    }
  }

  _handleAssetSelected(file) {
    if (this._externalHandlers.assetSelected == null) {
      return;
    }
    
    let event = new Event('asset-selected');
    event.detail = { asset: file };

    this._externalHandlers.assetSelected(event);
 }

  render() {
    const { title, files } = this.state;

    return (
      <div className="downloads-list">
        <div className="accordion">
          <label>{ title }</label>
          <div className="accordion-content">
            { 
              files.map((file) => {
                let name = FileUtils.getFileName(file.name);
                let data = file.data;
                let uid = file.uid;

                let thumbnail = defaultThumbnail;
                if (file.thumbnail !== null && file.thumbnail !== undefined) {
                  thumbnail = file.thumbnail.data;
                }

                return(
                  <div className="download-item" key={ uid } >
                    <div className="file-link-wrapper" style={ { display: !this.props.isBulkDownload ? 'block' : 'none' } }>
                      <Icon small>file_download</Icon>
                      <a className="link" href={ data } target="_blank" rel="noopener noreferrer">{ `${name} (${FileUtils.getHumanReadableSize(file.length)})` }</a>

                      <Link to={ AssetView.getPath({ id: uid }) } hidden={ !this._showThumbnails }>
                        <img src={ thumbnail } alt="Thumbnail" onError={ this.handleThumbnailError }></img>
                      </Link>
                    </div>
                    <div className="file-link-wrapper" style={ { display: this.props.isBulkDownload ? 'block' : 'none', fontSize: '10px' } }>
                      <Input type='checkbox'
                            checked={ this.props.selectedFiles.get(uid) !== undefined }
                            name={ `${name}` } 
                            value={ uid } 
                            label={ `${name} (${FileUtils.getHumanReadableSize(file.length)})` } 
                            key={ uid } 
                            onChange={ this._handleSelectedFileChange } 
                            style={ { marginBottom: '10px' } }/>
                      <img src={ thumbnail } alt="Thumbnail" onError={ this.handleThumbnailError } onClick={ () => { this._handleAssetSelected(file) } } style={ { display: this._showThumbnails ? 'block' : 'none' } }></img>
                    </div>
                    <div className="details-list">
                      <div className="row">
                        <div className="details-item">
                          <h2 className="property-name">Application</h2>
                          <h2 className="property-value">{ file.application ? file.application : '-' }</h2>
                        </div>
                        <div className="details-item">
                          <h2 className="property-name">Version</h2>
                          <h2 className="property-value">{ file.version ? file.version : '-' }</h2>
                        </div>
                      </div>
                      <div className="row">
                        <div className="details-item">
                          <h2 className="property-name">Submission Stage</h2>
                          <h2 className="property-value">{ file.submissionStage ? file.submissionStage : '-' }</h2>
                        </div>
                        <div className="details-item">
                          <h2 className="property-name">Submission Date</h2>
                          { file.submissionDate ? <Moment format={ CommonConstants.NUXEO_DATE_FORMAT }>{ file.submissionDate }</Moment> : <h2 className="property-value">-</h2> }
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default DownloadsList;
